import http from "./httpService";
import { AUTH_SYSTEM_URL, getClientAuth } from "./authService";

const API_PATH = '/myaccount';

export const getProfile = async (accessToken) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${AUTH_SYSTEM_URL}${API_PATH}/profile`, { headers });

    return data;
};

export const editProfile = async (accessToken, params) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.put(`${AUTH_SYSTEM_URL}${API_PATH}/profile`, params, { headers });

    return data;
};

export const editSecuritySettings = async (accessToken, params) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.put(`${AUTH_SYSTEM_URL}${API_PATH}/security`, params, { headers });

    return data;
};

export const getSubscriptions = async (accessToken) => {
    const headers = { 'Authorization': `Bearer ${accessToken}` };
    const { data } = await http.get(`${AUTH_SYSTEM_URL}${API_PATH}/subscriptions`, { headers });

    return data;
};

export const requestPasswordResetLink = async (email) => {
    //TODO: get bearer token without client auth
    const formData = new FormData();
    formData.append("grant_type", "client_credentials");
    const { data } = await http.post(`${AUTH_SYSTEM_URL}/oauth/token`, formData, getClientAuth());
    const token = data.access_token;

    return http.post(`${AUTH_SYSTEM_URL}/signin/recoverylink`, { email }, { headers:  { Authorization: `Bearer ${token}` }});
};

const accountService = {
    getProfile,
    editProfile,
    editSecuritySettings,
    getSubscriptions,
    requestPasswordResetLink
};

export default accountService;
